import React, { useCallback, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faPen, faShieldHalved, faBuildingColumns } from "@fortawesome/free-solid-svg-icons";
import api from "../../services/api";
import "./FluxopayReceivingAccountCard.css";

const formatDate = value => value
  ? new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeStyle: "short" }).format(new Date(value))
  : "Não informado";

export default function FluxopayReceivingAccountCard({ onEdit }) {
  const [destination, setDestination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await api.get("/api/fluxopay/payout-destination");
      setDestination(data?.destination || null);
    } catch (requestError) {
      setError(requestError?.response?.data?.message || "Não foi possível carregar a conta de recebimento.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <section className="fxpay-receiving"><p>Carregando conta de recebimento...</p></section>;
  if (error) return <section className="fxpay-receiving"><p className="fxpay-receiving__error">{error}</p></section>;

  const holdActive = destination?.security_hold_active;

  return (
    <section className="fxpay-receiving">
      <header>
        <div><small>CONTA DE RECEBIMENTO</small><h3>Destino dos repasses</h3></div>
        <span className={`fxpay-receiving__status ${destination?.status === "registered" ? "is-active" : ""}`}>
          {destination?.status_label || (destination ? "Cadastrada" : "Não cadastrada")}
        </span>
      </header>

      {!destination ? (
        <div className="fxpay-receiving__empty">
          <FontAwesomeIcon icon={faBuildingColumns} />
          <div><b>Nenhuma chave Pix cadastrada</b><p>Cadastre uma chave CNPJ de titularidade da clínica para solicitar repasses.</p></div>
          <button type="button" onClick={onEdit}>Cadastrar chave Pix</button>
        </div>
      ) : (
        <>
          <div className="fxpay-receiving__key">
            <span><FontAwesomeIcon icon={faShieldHalved} /></span>
            <div><small>Chave Pix protegida</small><strong>{destination.display_mask}</strong><p>{destination.pix_key_type} · somente para repasses da clínica</p></div>
          </div>
          <dl className="fxpay-receiving__details">
            <div><dt>Titular</dt><dd>{destination.holder_name}</dd></div>
            <div><dt>CNPJ</dt><dd>{destination.holder_document_masked || destination.display_mask}</dd></div>
            <div><dt>Situação</dt><dd>{destination.status_label || destination.status}</dd></div>
            <div><dt>Cadastrada em</dt><dd>{formatDate(destination.created_at)}</dd></div>
            <div><dt>Alterada por</dt><dd>{destination.updated_by?.name || destination.created_by?.name || "Sistema"}</dd></div>
            <div><dt>Última alteração</dt><dd>{formatDate(destination.key_changed_at || destination.updated_at)}</dd></div>
          </dl>
          <div className={`fxpay-receiving__hold ${holdActive ? "is-active" : ""}`}>
            <FontAwesomeIcon icon={faClock} />
            <div><b>{holdActive ? "Período de segurança ativo" : "Conta liberada para repasses"}</b><p>{holdActive ? `Alterações ficam protegidas até ${formatDate(destination.security_hold_ends_at)}.` : "Não há bloqueio de segurança vigente para esta chave."}</p></div>
          </div>
          <button type="button" className="fxpay-receiving__edit" onClick={onEdit} disabled={holdActive}>
            <FontAwesomeIcon icon={faPen} /> Alterar chave Pix
          </button>
        </>
      )}
    </section>
  );
}
